import { memo, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { noop } from 'shell/utils/noop';
import { useFormikContext } from 'formik';
import { HistoryCohabitationVM } from 'cohabitation/view-models/history-cohabitation';

const AccordionFamilyDataComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formikContext = useFormikContext<HistoryCohabitationVM>();

  const { cohabitationData } = formikContext.values;

  return (
    <Accordion expanded={open} onChange={() => setOpen(!open)}>
      <AccordionSummary
        aria-controls="panel-cohabitation-data-content"
        id="panel-cohabitation-data-content"
        expandIcon={<ExpandMore />}
      >
        <Typography>Dati Convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <PmiTextField
              id="idFamilyAnpr"
              label="Cd ANPR"
              aria-label="Cd ANPR"
              fullWidth
              disabled
              value={cohabitationData?.idAnpr}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <PmiTextField
              id="idSipo"
              label="Cd Sipo"
              aria-label="Cd Sipo"
              fullWidth
              disabled
              value={cohabitationData?.idSipo}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <PmiTextField
              id="type"
              label="Tipologia"
              aria-label="Tipologia"
              fullWidth
              disabled
              value={cohabitationData?.type}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DatePicker
              label="Data creazione"
              aria-label="Data creazione"
              value={cohabitationData?.creationDate || null}
              onChange={noop}
              disabled
              renderInput={(params) => (
                <PmiTextField {...params} id="creationDate" helperText="" error={false} fullWidth />
              )}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <PmiTextField
              id="description"
              label="Descrizione"
              aria-label="Descrizione"
              fullWidth
              value={cohabitationData?.description}
              disabled
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

AccordionFamilyDataComponent.displayName = 'Change control data accordion component';

const AccordionFamilyData = memo(AccordionFamilyDataComponent);

export default AccordionFamilyData;
